var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5369 16.6665H5.46275C5.20775 16.6665 5.00025 16.4798 5.00025 16.2498V3.74984C5.00025 3.51984 5.20775 3.33317 5.46275 3.33317H9.16691V6.7915C9.16691 8.1015 10.1811 9.1665 11.4286 9.1665H15.0002V16.2498C15.0002 16.4798 14.7919 16.6665 14.5369 16.6665ZM14.7077 7.49984H11.4286C11.1002 7.49984 10.8336 7.18234 10.8336 6.7915V3.33317H10.9269L14.7077 7.49984ZM16.4502 6.93984L11.9136 1.93984C11.7561 1.76567 11.5319 1.6665 11.2961 1.6665H5.46275C4.28858 1.6665 3.33358 2.6015 3.33358 3.74984V16.2498C3.33358 17.3982 4.28858 18.3332 5.46275 18.3332H14.5369C15.7111 18.3332 16.6669 17.3982 16.6669 16.2498V7.49984C16.6669 7.29234 16.5894 7.09317 16.4502 6.93984Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.8df2b8ab5206ad81d2c927481997424e.svg";
export { ForwardRef as ReactComponent };